export const TYPE_TRANSFORM = {
	basic_commission: 'Basic Commision',
	jp: 'JP',
	adp: 'ADP',
};
